import { render } from "./GlucoseListItem.vue?vue&type=template&id=6b3893be&scoped=true"
import script from "./GlucoseListItem.vue?vue&type=script&lang=js"
export * from "./GlucoseListItem.vue?vue&type=script&lang=js"

import "./GlucoseListItem.vue?vue&type=style&index=0&id=6b3893be&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3893be"]])

export default __exports__